import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { brandRoute } from "../../platform/routes";
import { SoundsScreen } from "./SoundsScreen";

// `?view=`: the page's tab, the brand's audio library (the default, as live) or My Generations.
// Anything malformed is dropped.
const soundsSearch = z.object({
  view: z.enum(["library", "generations"]).optional().catch(undefined),
});

/** Live's Sounds page (`/app/sounds`): a brand's audio, so it hangs under the brand. */
export const soundsRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "sounds",
  validateSearch: (search) => soundsSearch.parse(search),
  component: SoundsScreen,
});
